<template>
  <div>
    <CRow>
      <CCol>
        <h4 class="mb-3">Reporte de horarios de envio</h4>
      </CCol>
    </CRow>

    <send-time-report-filters
      v-model="filters"
      :accounts="accounts"
      @apply="applyFilters"
    />

    <CAlert color="danger" v-if="errorMessage" class="mb-3">
      {{ errorMessage }}
    </CAlert>

    <send-time-kpi-cards :kpis="summary.kpis || {}" />

    <reading-time-distribution-card
      :distribution="summary.distribution || {}"
    />

    <send-time-heatmap
      :cells="heatmap.cells || []"
      :metric="filters.metric"
    />

    <best-send-times-table :rows="bestSlots.rows || []" />

    <CRow>
      <CCol md="6">
        <hourly-performance-chart
          :rows="byHour.rows || []"
          :metric="metricForBars"
        />
      </CCol>
      <CCol md="6">
        <weekday-performance-chart :rows="byWeekday.rows || []" />
      </CCol>
    </CRow>

    <scheduled-vs-manual-card :rows="scheduledVsManual.rows || []" />

    <message-type-performance-table :rows="messageTypes.rows || []" />

    <webhook-data-quality-card :data-quality="dataQuality" />

  </div>
</template>

<script>
import accountService from '@/services/account'
import reportService from '@/services/send_time_reports'
import SendTimeReportFilters from '@/components/administrator/send-time-report/SendTimeReportFilters'
import SendTimeKpiCards from '@/components/administrator/send-time-report/SendTimeKpiCards'
import SendTimeHeatmap from '@/components/administrator/send-time-report/SendTimeHeatmap'
import BestSendTimesTable from '@/components/administrator/send-time-report/BestSendTimesTable'
import HourlyPerformanceChart from '@/components/administrator/send-time-report/HourlyPerformanceChart'
import WeekdayPerformanceChart from '@/components/administrator/send-time-report/WeekdayPerformanceChart'
import ScheduledVsManualCard from '@/components/administrator/send-time-report/ScheduledVsManualCard'
import MessageTypePerformanceTable from '@/components/administrator/send-time-report/MessageTypePerformanceTable'
import ReadingTimeDistributionCard from '@/components/administrator/send-time-report/ReadingTimeDistributionCard'
import WebhookDataQualityCard from '@/components/administrator/send-time-report/WebhookDataQualityCard'
import store from '@/store'

export default {
  name: 'SendTimeReport',
  components: {
    SendTimeReportFilters,
    SendTimeKpiCards,
    SendTimeHeatmap,
    BestSendTimesTable,
    HourlyPerformanceChart,
    WeekdayPerformanceChart,
    ScheduledVsManualCard,
    MessageTypePerformanceTable,
    ReadingTimeDistributionCard,
    WebhookDataQualityCard,
  },
  data() {
    return {
      errorMessage: '',
      accounts: [],
      filters: {
        range: 'last_30_days',
        start_date: '',
        end_date: '',
        account_id: 0,
        message_type: '',
        status: '',
        send_origin: 'all',
        weekday: 0,
        min_sample: 1,
        metric: 'read_rate',
      },
      summary: {},
      heatmap: {},
      bestSlots: {},
      byHour: {},
      byWeekday: {},
      messageTypes: {},
      scheduledVsManual: {},
      dataQuality: {},
    }
  },
  computed: {
    metricForBars() {
      const allowed = ['read_rate', 'response_rate', 'delivery_rate', 'error_rate']
      if (!allowed.includes(this.filters.metric)) {
        return 'read_rate'
      }
      return this.filters.metric
    },
  },
  mounted: async function() {
    await this.loadAccounts()
    await this.loadReport()
  },
  methods: {
    async loadAccounts() {
      try {
        const response = await accountService.getAccounts({ page: 1, quantity: 200 })
        const rows = Array.isArray(response && response.data)
          ? response.data
          : ((response && response.data && response.data.records) || [])

        this.accounts = rows.map((item) => ({
          id: item.id,
          name: item.name || `Cuenta ${item.id}`,
        }))
      } catch (error) {
        this.accounts = []
      }
    },
    async applyFilters(nextFilters) {
      this.filters = {
        ...this.filters,
        ...nextFilters,
      }
      await this.loadReport()
    },
    async loadReport() {
      this.loading()
      this.errorMessage = ''

      try {
        const response = await reportService.getDashboard(this.filters)
        const payload = (response && response.data) || {}

        this.summary = payload.summary || {}
        this.heatmap = payload.heatmap || {}
        this.bestSlots = payload.best_slots || {}
        this.byHour = payload.by_hour || {}
        this.byWeekday = payload.by_weekday || {}
        this.messageTypes = payload.by_message_type || {}
        this.scheduledVsManual = payload.scheduled_vs_manual || {}
        this.dataQuality = (payload.data_quality && payload.data_quality.data_quality) || {}
      } catch (error) {
        this.errorMessage = (error && error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'No fue posible cargar el reporte de horarios de envio.'
      } finally {
        this.loaded()
      }
    },
    loading() {
      store.commit('loading')
    },
    loaded() {
      store.commit('loaded')
    },
  },
}
</script>
